var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import IconWrapper from "./IconWrapper";
export default React.forwardRef((_a, ref) => {
    var { color, size = "default", sizeRatio } = _a, otherProps = __rest(_a, ["color", "size", "sizeRatio"]);
    const sizeRatioNormalized = sizeRatio
        ? sizeRatio
        : size === "default"
            ? 1.5
            : 1;
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 16, height: 16, color: color, sizeRatio: sizeRatioNormalized }, otherProps),
        React.createElement("path", { d: "M11.7803 5.28033C12.0732 4.98744 12.0732 4.51256 11.7803 4.21967C11.4874 3.92678 11.0126 3.92678 10.7197 4.21967L8 6.93934L5.28033 4.21967C4.98744 3.92678 4.51256 3.92678 4.21967 4.21967C3.92678 4.51256 3.92678 4.98744 4.21967 5.28033L6.93934 8L4.21967 10.7197C3.92678 11.0126 3.92678 11.4874 4.21967 11.7803C4.51256 12.0732 4.98744 12.0732 5.28033 11.7803L8 9.06066L10.7197 11.7803C11.0126 12.0732 11.4874 12.0732 11.7803 11.7803C12.0732 11.4874 12.0732 11.0126 11.7803 10.7197L9.06066 8L11.7803 5.28033Z" })));
});
//# sourceMappingURL=Close.js.map